angular
	.module('inputPassword.components', [])
	.component('inputPassword', {
		templateUrl: 'ng/components/inputPassword/inputPassword.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			inputPlaceholder: '@',
			formName: '=',
			bindingVariable: '=',
			if: '@'
		},
		controllerAs: 'inputPasswordCtrl',
		controller: function ($translate, validationService) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;

				//var passwordInput = document.querySelector('.password-input');
				//passwordInput.onpaste = function(e) {
				//	e.preventDefault();
				//};
			}

			self.$onChanges = function () {

			}

			self.errorMsgShown = false;
			self.validationService = validationService;

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}
		}
	});